export const CountrySectionData = {
    countries: [
      {
        country: "India",
        currency: "INR",
        employer_contributions: {
          pension_contribution: {
            rate: 12.0,
            description: "Provident Fund (PF) and Pension Scheme (EPS) for employers with more than 20 employees.",
          },
          insurance_contribution: {
            rate: 3.25,
            description: "Employee State Insurance (ESI) for employees earning up to 21,000 INR per month.",
          },
          total_employer_contribution: {
            rate: 16.75,
            description: "Total employer contribution as a percentage of applicable income.",
          },
        },
        employee_contributions: {
          pension_contribution: {
            rate: 12.0,
            description: "Provident Fund (PF) and Pension Scheme (EPS) for employees.",
          },
          insurance_contribution: {
            rate: 0.75,
            description: "Employee State Insurance (ESI) for employees earning up to 21,000 INR per month.",
          },
          total_employee_contribution: {
            rate: 18.08,
            description: "Total employee contribution as a percentage of applicable income.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 300,000 INR", rate: 0.0 },
          { range: "300,001 - 600,000 INR", rate: 5.0 },
          { range: "600,001 - 900,000 INR", rate: 10.0 },
          { range: "900,001 - 1,200,000 INR", rate: 15.0 },
          { range: "1,200,001 - 1,500,000 INR", rate: 20.0 },
          { range: "Over 1,500,001 INR", rate: 30.0 },
        ],
      },
      {
        country: "United Kingdom",
        currency: "GBP",
        employer_contributions: {
          pension_contribution: {
            rate: 3.0,
            description: "Workplace Pension applied to income between £533 and £4,189.17 per month.",
          },
          insurance_contribution: {
            rate: 13.8,
            description: "National Insurance (NI) applied on income above £1,048 per month.",
          },
          total_employer_contribution: {
            rate: 17.3,
            description: "Total employer contribution as a percentage of applicable income.",
          },
        },
        employee_contributions: {
          pension_contribution: {
            rate: 5.0,
            description: "Workplace Pension applied to income between £533 and £4,189.17 per month.",
          },
          insurance_contribution_tier1: {
            rate: 10.0,
            description: "National Insurance (NI) for income between £758 and £4,189 per month.",
          },
          total_employee_contribution: {
            rate: 15.0,
            description: "Total employee contribution as a percentage of applicable income.",
          },
        },
        income_tax_slabs: [
          { range: "Up to 12,570 GBP", rate: 0.0 },
          { range: "12,571 - 37,700 GBP", rate: 20.0 },
          { range: "37,701 - 125,140 GBP", rate: 40.0 },
          { range: "Over 125,140 GBP", rate: 45.0 },
        ],
      },
      {
        country: "USA",
        currency: "USD",
        employer_contributions: {
          social_security: {
            rate: 6.2,
            description: "Social Security contribution on income up to $147,000 annually.",
          },
          medicare: {
            rate: 1.45,
            description: "Medicare contribution on all wages.",
          },
          total_employer_contribution: {
            rate: 7.65,
            description: "Total employer contribution including Social Security and Medicare.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 6.2,
            description: "Social Security contribution on income up to $147,000 annually.",
          },
          medicare: {
            rate: 1.45,
            description: "Medicare contribution on all wages.",
          },
          total_employee_contribution: {
            rate: 7.65,
            description: "Total employee contribution including Social Security and Medicare.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 9,875 USD", rate: 10.0 },
          { range: "9,876 - 40,125 USD", rate: 12.0 },
          { range: "40,126 - 85,525 USD", rate: 22.0 },
          { range: "85,526 - 163,300 USD", rate: 24.0 },
          { range: "163,301 - 207,350 USD", rate: 32.0 },
          { range: "207,351 - 518,400 USD", rate: 35.0 },
          { range: "Over 518,401 USD", rate: 37.0 },
        ],
      },
      {
        country: "Canada",
        currency: "CAD",
        employer_contributions: {
          cpp: {
            rate: 5.95,
            description: "Canada Pension Plan contributions.",
          },
          ei: {
            rate: 2.21,
            description: "Employment Insurance contributions.",
          },
          total_employer_contribution: {
            rate: 8.16,
            description: "Total employer contribution including CPP and EI.",
          },
        },
        employee_contributions: {
          cpp: {
            rate: 5.95,
            description: "Canada Pension Plan contributions.",
          },
          ei: {
            rate: 1.58,
            description: "Employment Insurance contributions.",
          },
          total_employee_contribution: {
            rate: 7.53,
            description: "Total employee contribution including CPP and EI.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 49,020 CAD", rate: 15.0 },
          { range: "49,021 - 98,040 CAD", rate: 20.5 },
          { range: "98,041 - 151,978 CAD", rate: 26.0 },
          { range: "151,979 - 216,511 CAD", rate: 29.0 },
          { range: "Over 216,512 CAD", rate: 33.0 },
        ],
      },
      {
        country: "Germany",
        currency: "EUR",
        employer_contributions: {
          social_security: {
            rate: 18.6,
            description: "Employer contributions to health, pension, and unemployment insurance.",
          },
          total_employer_contribution: {
            rate: 18.6,
            description: "Total employer contribution including all social security components.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 20.0,
            description: "Employee contributions to health, pension, and unemployment insurance.",
          },
          total_employee_contribution: {
            rate: 20.0,
            description: "Total employee contribution including all social security components.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 9,744 EUR", rate: 0.0 },
          { range: "9,745 - 57,918 EUR", rate: 14.0 },
          { range: "57,919 - 274,612 EUR", rate: 42.0 },
          { range: "Over 274,613 EUR", rate: 45.0 },
        ],
      },
      {
        country: "France",
        currency: "EUR",
        employer_contributions: {
          social_security: {
            rate: 27.0,
            description: "Contributions towards health, pension, and other insurances.",
          },
          total_employer_contribution: {
            rate: 27.0,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 22.0,
            description: "Employee contributions towards health, pension, and other insurances.",
          },
          total_employee_contribution: {
            rate: 22.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 10,084 EUR", rate: 0.0 },
          { range: "10,085 - 25,710 EUR", rate: 11.0 },
          { range: "25,711 - 73,516 EUR", rate: 30.0 },
          { range: "73,517 - 158,122 EUR", rate: 41.0 },
          { range: "Over 158,122 EUR", rate: 45.0 },
        ],
      },
      {
        country: "Netherlands",
        currency: "EUR",
        employer_contributions: {
          social_security: {
            rate: 18.0,
            description: "Contributions for healthcare, unemployment, and other social security.",
          },
          total_employer_contribution: {
            rate: 18.0,
            description: "Total employer contributions as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 12.0,
            description: "Employee contributions for healthcare and other insurances.",
          },
          total_employee_contribution: {
            rate: 12.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 68,508 EUR", rate: 37.07 },
          { range: "Over 68,508 EUR", rate: 49.5 },
        ],
      },
      {
        country: "Belgium",
        currency: "EUR",
        employer_contributions: {
          social_security: {
            rate: 25.0,
            description: "Employer contributions towards pensions, healthcare, and unemployment.",
          },
          total_employer_contribution: {
            rate: 25.0,
            description: "Total employer contributions as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 13.07,
            description: "Employee contributions for pensions, healthcare, and unemployment.",
          },
          total_employee_contribution: {
            rate: 13.07,
            description: "Total employee contributions as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 13,540 EUR", rate: 25.0 },
          { range: "13,541 - 23,900 EUR", rate: 40.0 },
          { range: "23,901 - 41,360 EUR", rate: 45.0 },
          { range: "Over 41,361 EUR", rate: 50.0 },
        ],
      },
      {
        country: "Sweden",
        currency: "SEK",
        employer_contributions: {
          social_security: {
            rate: 31.42,
            description: "Social security contributions covering pensions, healthcare, and more.",
          },
          total_employer_contribution: {
            rate: 31.42,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 7.0,
            description: "Employee contributions for healthcare and pensions.",
          },
          total_employee_contribution: {
            rate: 7.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 540,700 SEK", rate: 30.0 },
          { range: "Over 540,700 SEK", rate: 50.0 },
        ],
      },
      {
        country: "Poland",
        currency: "PLN",
        employer_contributions: {
          social_security: {
            rate: 21.36,
            description: "Employer contributions for pensions, healthcare, and more.",
          },
          total_employer_contribution: {
            rate: 21.36,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 13.71,
            description: "Employee contributions for healthcare and pensions.",
          },
          total_employee_contribution: {
            rate: 13.71,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 120,000 PLN", rate: 17.0 },
          { range: "Over 120,000 PLN", rate: 32.0 },
        ],
      },
      {
        country: "Hungary",
        currency: "HUF",
        employer_contributions: {
          social_security: {
            rate: 15.5,
            description: "Employer contributions for pensions, healthcare, and other insurances.",
          },
          total_employer_contribution: {
            rate: 15.5,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 18.5,
            description: "Employee contributions for pensions, healthcare, and other insurances.",
          },
          total_employee_contribution: {
            rate: 18.5,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "All income", rate: 15.0 },
        ],
      },
      {
        country: "Switzerland",
        currency: "CHF",
        employer_contributions: {
          social_security: {
            rate: 12.5,
            description: "Employer contributions for old-age pension, unemployment, and insurance.",
          },
          total_employer_contribution: {
            rate: 12.5,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 6.25,
            description: "Employee contributions for old-age pension, unemployment, and insurance.",
          },
          total_employee_contribution: {
            rate: 6.25,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "Varies by canton", rate: "Average 20.0" },
        ],
      },
      {
        country: "Greece",
        currency: "EUR",
        employer_contributions: {
          social_security: {
            rate: 24.3,
            description: "Employer contributions for healthcare, pensions, and unemployment.",
          },
          total_employer_contribution: {
            rate: 24.3,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 16.0,
            description: "Employee contributions for healthcare, pensions, and unemployment.",
          },
          total_employee_contribution: {
            rate: 16.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 10,000 EUR", rate: 9.0 },
          { range: "10,001 - 20,000 EUR", rate: 22.0 },
          { range: "20,001 - 30,000 EUR", rate: 28.0 },
          { range: "30,001 - 40,000 EUR", rate: 36.0 },
          { range: "Over 40,000 EUR", rate: 44.0 },
        ],
      },
      {
        country: "Malta",
        currency: "EUR",
        employer_contributions: {
          social_security: {
            rate: 10.0,
            description: "Employer contributions for social security covering various benefits.",
          },
          total_employer_contribution: {
            rate: 10.0,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 10.0,
            description: "Employee contributions for social security covering various benefits.",
          },
          total_employee_contribution: {
            rate: 10.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 9,100 EUR", rate: 0.0 },
          { range: "9,101 - 14,500 EUR", rate: 15.0 },
          { range: "14,501 - 19,500 EUR", rate: 25.0 },
          { range: "Over 19,501 EUR", rate: 35.0 },
        ],
      },
      {
        country: "Croatia",
        currency: "HRK",
        employer_contributions: {
          social_security: {
            rate: 16.5,
            description: "Employer contributions for healthcare, pensions, and unemployment.",
          },
          total_employer_contribution: {
            rate: 16.5,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 20.0,
            description: "Employee contributions for healthcare, pensions, and unemployment.",
          },
          total_employee_contribution: {
            rate: 20.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 3,800 HRK", rate: 12.0 },
          { range: "3,801 - 30,000 HRK", rate: 25.0 },
          { range: "Over 30,000 HRK", rate: 40.0 },
        ],
      },
      {
        country: "Czech Republic",
        currency: "CZK",
        employer_contributions: {
          social_security: {
            rate: 33.8,
            description: "Employer contributions for healthcare, pensions, and unemployment.",
          },
          total_employer_contribution: {
            rate: 33.8,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 11.0,
            description: "Employee contributions for healthcare, pensions, and unemployment.",
          },
          total_employee_contribution: {
            rate: 11.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 48 times average salary", rate: 15.0 },
          { range: "Over 48 times average salary", rate: 23.0 },
        ],
      },
      {
        country: "Denmark",
        currency: "DKK",
        employer_contributions: {
          social_security: {
            rate: 0.0,
            description: "Minimal employer social security contributions; healthcare funded through taxes.",
          },
          total_employer_contribution: {
            rate: 0.0,
            description: "No significant employer contributions.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 8.0,
            description: "Employee contributions for labor market fund and ATP pension.",
          },
          total_employee_contribution: {
            rate: 8.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 50,217 DKK", rate: 0.0 },
          { range: "50,218 - 544,800 DKK", rate: 12.16 },
          { range: "Over 544,800 DKK", rate: 15.0 },
        ],
      },
      {
        country: "Ireland",
        currency: "EUR",
        employer_contributions: {
          social_security: {
            rate: 11.05,
            description: "Employer contributions for PRSI (Pay-Related Social Insurance).",
          },
          total_employer_contribution: {
            rate: 11.05,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 4.0,
            description: "Employee contributions for PRSI and USC (Universal Social Charge).",
          },
          total_employee_contribution: {
            rate: 4.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 36,800 EUR", rate: 20.0 },
          { range: "Over 36,800 EUR", rate: 40.0 },
        ],
      },
      {
        country: "Portugal",
        currency: "EUR",
        employer_contributions: {
          social_security: {
            rate: 23.75,
            description: "Employer contributions for social security covering pensions, healthcare, and more.",
          },
          total_employer_contribution: {
            rate: 23.75,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 11.0,
            description: "Employee contributions for social security.",
          },
          total_employee_contribution: {
            rate: 11.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 7,112 EUR", rate: 14.5 },
          { range: "7,113 - 10,732 EUR", rate: 23.0 },
          { range: "10,733 - 20,322 EUR", rate: 28.5 },
          { range: "20,323 - 25,075 EUR", rate: 35.0 },
          { range: "Over 25,075 EUR", rate: 48.0 },
        ],
      },
      {
        country: "Romania",
        currency: "RON",
        employer_contributions: {
          social_security: {
            rate: 2.25,
            description: "Employer contributions for social security and unemployment insurance.",
          },
          total_employer_contribution: {
            rate: 2.25,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 35.0,
            description: "Employee contributions for pensions, healthcare, and unemployment.",
          },
          total_employee_contribution: {
            rate: 35.0,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "Flat rate", rate: 10.0 },
        ],
      },
      {
        country: "Slovakia",
        currency: "EUR",
        employer_contributions: {
          social_security: {
            rate: 34.6,
            description: "Employer contributions for healthcare, pensions, and unemployment.",
          },
          total_employer_contribution: {
            rate: 34.6,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 13.4,
            description: "Employee contributions for healthcare, pensions, and unemployment.",
          },
          total_employee_contribution: {
            rate: 13.4,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 38,553 EUR", rate: 19.0 },
          { range: "Over 38,553 EUR", rate: 25.0 },
        ],
      },
      {
        country: "Spain",
        currency: "EUR",
        employer_contributions: {
          social_security: {
            rate: 29.9,
            description: "Employer contributions covering pensions, healthcare, and other benefits.",
          },
          total_employer_contribution: {
            rate: 29.9,
            description: "Total employer contribution as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 6.35,
            description: "Employee contributions covering pensions and healthcare.",
          },
          total_employee_contribution: {
            rate: 6.35,
            description: "Total employee contribution as a percentage of gross salary.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 12,450 EUR", rate: 19.0 },
          { range: "12,451 - 20,200 EUR", rate: 24.0 },
          { range: "20,201 - 35,200 EUR", rate: 30.0 },
          { range: "35,201 - 60,000 EUR", rate: 37.0 },
          { range: "Over 60,000 EUR", rate: 45.0 },
        ],
      },
      {
        country: "South Africa",
        currency: "ZAR",
        employer_contributions: {
          social_security: {
            rate: 1.0,
            description: "Employer contributions to UIF (Unemployment Insurance Fund).",
          },
          skills_development_levy: {
            rate: 1.0,
            description: "Employer contributions to Skills Development Levy (SDL).",
          },
          oid: {
            rate: "2% and up",
            description: "Employer contributions to the Occupational Injuries and Diseases Fund (OID), varies by risk profile.",
          },
          total_employer_contribution: {
            rate: "2.0% and up",
            description: "Total employer contributions, including UIF, SDL, and OID.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 1.0,
            description: "Employee contributions to UIF (Unemployment Insurance Fund).",
          },
          total_employee_contribution: {
            rate: 1.0,
            description: "Total employee contributions (only UIF).",
          },
        },
        income_tax_slabs: [
          { range: "0 - 237,100 ZAR", rate: 18.0 },
          { range: "237,101 - 370,500 ZAR", rate: 26.0 },
          { range: "370,501 - 512,800 ZAR", rate: 31.0 },
          { range: "512,801 - 673,000 ZAR", rate: 36.0 },
          { range: "Over 673,000 ZAR", rate: 41.0 },
        ],
      },      
      {
        country: "UAE",
        currency: "AED",
        employer_contributions: {
          social_security: {
            rate: 12.5,
            description: "Employer contributions for UAE nationals (GCC citizens may have similar rates).",
          },
          total_employer_contribution: {
            rate: 12.5,
            description: "Total employer contributions as a percentage of gross salary for UAE nationals.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 5.0,
            description: "Employee contributions for UAE nationals.",
          },
          total_employee_contribution: {
            rate: 5.0,
            description: "Total employee contributions as a percentage of gross salary for UAE nationals.",
          },
        },
        income_tax_slabs: [
          { range: "No income tax", rate: 0.0 },
        ],
      },
      {
        country: "Australia",
        currency: "AUD",
        employer_contributions: {
          social_security: {
            rate: 10.5,
            description: "Employer contributions to superannuation funds.",
          },
          total_employer_contribution: {
            rate: 10.5,
            description: "Total employer contributions as a percentage of gross salary.",
          },
        },
        employee_contributions: {
          social_security: {
            rate: 0.0,
            description: "No mandatory employee contributions.",
          },
          total_employee_contribution: {
            rate: 0.0,
            description: "No employee contributions to superannuation.",
          },
        },
        income_tax_slabs: [
          { range: "0 - 18,200 AUD", rate: 0.0 },
          { range: "18,201 - 45,000 AUD", rate: 19.0 },
          { range: "45,001 - 120,000 AUD", rate: 32.5 },
          { range: "120,001 - 180,000 AUD", rate: 37.0 },
          { range: "Over 180,000 AUD", rate: 45.0 },
        ],
      },
      {
        country: "Thailand",
        currency: "THB",
        employer_contributions: {
            social_security: {
                rate: 5.0,
                description: "Social security contributions (employer's share).",
            },
            employee_health: {
                rate: 0.75,
                description: "Employee health insurance contribution (employer's share).",
            },
            total_employer_contribution: {
                rate: 5.75,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            social_security: {
                rate: 5.0,
                description: "Social security contributions (employee's share).",
            },
            health_insurance: {
                rate: 0.75,
                description: "Health insurance contributions (employee's share).",
            },
            total_employee_contribution: {
                rate: 5.75,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "0 - 150,000 THB", rate: 0.0 },
            { range: "150,001 - 300,000 THB", rate: 5.0 },
            { range: "300,001 - 500,000 THB", rate: 10.0 },
            { range: "500,001 - 750,000 THB", rate: 15.0 },
            { range: "750,001 - 1,000,000 THB", rate: 20.0 },
            { range: "Above 1,000,000 THB", rate: 25.0 },
        ],
    },
    {
        country: "Indonesia (West Indo)",
        currency: "IDR",
        employer_contributions: {
            social_security: {
                rate: 6.0,
                description: "Social security contributions for employee's retirement and health insurance.",
            },
            health_insurance: {
                rate: 4.0,
                description: "Health insurance contributions.",
            },
            total_employer_contribution: {
                rate: 10.0,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            social_security: {
                rate: 2.0,
                description: "Social security contributions from employees.",
            },
            health_insurance: {
                rate: 1.0,
                description: "Health insurance contributions from employees.",
            },
            total_employee_contribution: {
                rate: 3.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "0 - 50,000,000 IDR", rate: 5.0 },
            { range: "50,000,001 - 250,000,000 IDR", rate: 15.0 },
            { range: "250,000,001 - 500,000,000 IDR", rate: 25.0 },
            { range: "Above 500,000,000 IDR", rate: 30.0 },
        ],
    },
    {
        country: "South Korea",
        currency: "KRW",
        employer_contributions: {
            national_pension: {
                rate: 4.5,
                description: "National Pension Scheme contributions by employers.",
            },
            health_insurance: {
                rate: 6.0,
                description: "Health insurance contributions by employers.",
            },
            unemployment_insurance: {
                rate: 1.3,
                description: "Unemployment insurance contributions by employers.",
            },
            total_employer_contribution: {
                rate: 11.8,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            national_pension: {
                rate: 4.5,
                description: "National Pension Scheme contributions by employees.",
            },
            health_insurance: {
                rate: 3.0,
                description: "Health insurance contributions by employees.",
            },
            unemployment_insurance: {
                rate: 0.8,
                description: "Unemployment insurance contributions by employees.",
            },
            total_employee_contribution: {
                rate: 8.3,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "Up to 12 million KRW", rate: 6.0 },
            { range: "12 million - 46 million KRW", rate: 15.0 },
            { range: "46 million - 88 million KRW", rate: 24.0 },
            { range: "Above 88 million KRW", rate: 35.0 },
        ],
    },
    {
        country: "Philippines",
        currency: "PHP",
        employer_contributions: {
            social_security: {
                rate: 7.37,
                description: "Social Security System (SSS) contributions by employers.",
            },
            health_insurance: {
                rate: 3.0,
                description: "PhilHealth contributions by employers.",
            },
            total_employer_contribution: {
                rate: 10.37,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            social_security: {
                rate: 4.37,
                description: "Social Security System (SSS) contributions by employees.",
            },
            health_insurance: {
                rate: 2.75,
                description: "PhilHealth contributions by employees.",
            },
            total_employee_contribution: {
                rate: 7.12,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "0 - 250,000 PHP", rate: 0.0 },
            { range: "250,001 - 400,000 PHP", rate: 20.0 },
            { range: "400,001 - 800,000 PHP", rate: 25.0 },
            { range: "800,001 - 2,000,000 PHP", rate: 30.0 },
            { range: "2,000,001 - 8,000,000 PHP", rate: 32.0 },
            { range: "Above 8,000,000 PHP", rate: 35.0 },
        ],
    },
    {
        country: "Malaysia",
        currency: "MYR",
        employer_contributions: {
            social_security: {
                rate: 13.0,
                description: "Social security contributions by employers.",
            },
            health_insurance: {
                rate: 0.0,
                description: "No direct health insurance contribution by employers.",
            },
            total_employer_contribution: {
                rate: 13.0,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            social_security: {
                rate: 11.0,
                description: "Social security contributions by employees.",
            },
            health_insurance: {
                rate: 0.0,
                description: "No direct health insurance contribution by employees.",
            },
            total_employee_contribution: {
                rate: 11.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "Up to 5,000 MYR", rate: 0.0 },
            { range: "5,001 - 20,000 MYR", rate: 1.0 },
            { range: "20,001 - 35,000 MYR", rate: 3.0 },
            { range: "35,001 - 50,000 MYR", rate: 8.0 },
            { range: "50,001 - 70,000 MYR", rate: 14.0 },
            { range: "Above 70,000 MYR", rate: 24.0 },
        ],
    },
    {
        country: "Singapore",
        currency: "SGD",
        employer_contributions: {
            central_provident_fund: {
                rate: 17.0,
                description: "Employer contribution to the Central Provident Fund (CPF).",
            },
            total_employer_contribution: {
                rate: 17.0,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            central_provident_fund: {
                rate: 20.0,
                description: "Employee contribution to the Central Provident Fund (CPF).",
            },
            total_employee_contribution: {
                rate: 20.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "Up to 20,000 SGD", rate: 0.0 },
            { range: "20,001 - 30,000 SGD", rate: 2.0 },
            { range: "30,001 - 40,000 SGD", rate: 3.5 },
            { range: "40,001 - 80,000 SGD", rate: 7.0 },
            { range: "80,001 - 120,000 SGD", rate: 11.5 },
            { range: "120,001 - 160,000 SGD", rate: 15.0 },
            { range: "Above 160,000 SGD", rate: 18.0 },
        ],
    },
    {
        country: "Hong Kong",
        currency: "HKD",
        employer_contributions: {
            provident_fund: {
                rate: 5.0,
                description: "Employer contribution to the Mandatory Provident Fund (MPF).",
            },
            total_employer_contribution: {
                rate: 5.0,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            provident_fund: {
                rate: 5.0,
                description: "Employee contribution to the Mandatory Provident Fund (MPF).",
            },
            total_employee_contribution: {
                rate: 5.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "0 - 50,000 HKD", rate: 2.0 },
            { range: "50,001 - 100,000 HKD", rate: 6.0 },
            { range: "100,001 - 150,000 HKD", rate: 10.0 },
            { range: "150,001 - 200,000 HKD", rate: 14.0 },
            { range: "Above 200,000 HKD", rate: 17.0 },
        ],
    },
    {
        country: "Croatia",
        currency: "HRK",
        employer_contributions: {
            pension_contribution: {
                rate: 15.0,
                description: "Mandatory contributions for pension insurance.",
            },
            health_insurance: {
                rate: 16.5,
                description: "Health insurance contributions.",
            },
            total_employer_contribution: {
                rate: 31.5,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            pension_contribution: {
                rate: 5.0,
                description: "Mandatory contributions for pension insurance.",
            },
            health_insurance: {
                rate: 0.0,
                description: "No direct health insurance contribution from employees.",
            },
            total_employee_contribution: {
                rate: 5.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "0 - 3,800 HRK", rate: 20.0 },
            { range: "Above 3,800 HRK", rate: 30.0 },
        ],
    },
    {
        country: "Czech Republic",
        currency: "CZK",
        employer_contributions: {
            social_security: {
                rate: 24.8,
                description: "Social security contributions.",
            },
            health_insurance: {
                rate: 9.0,
                description: "Health insurance contributions.",
            },
            total_employer_contribution: {
                rate: 33.8,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            social_security: {
                rate: 6.5,
                description: "Social security contributions.",
            },
            health_insurance: {
                rate: 4.5,
                description: "Health insurance contributions.",
            },
            total_employee_contribution: {
                rate: 11.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "Up to 48,000 CZK", rate: 15.0 },
            { range: "Above 48,000 CZK", rate: 23.0 },
        ],
    },
    {
        country: "Egypt",
        currency: "EGP",
        employer_contributions: {
            social_insurance: {
                rate: 18.75,
                description: "Contributions to social insurance.",
            },
            total_employer_contribution: {
                rate: 18.75,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            social_insurance: {
                rate: 14.0,
                description: "Contributions to social insurance.",
            },
            total_employee_contribution: {
                rate: 14.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "0 - 15,000 EGP", rate: 0.0 },
            { range: "15,001 - 30,000 EGP", rate: 2.5 },
            { range: "30,001 - 45,000 EGP", rate: 10.0 },
            { range: "45,001 - 60,000 EGP", rate: 15.0 },
            { range: "Above 60,000 EGP", rate: 20.0 },
        ],
    },
    {
        country: "New Zealand",
        currency: "NZD",
        employer_contributions: {
            kiwi_saver: {
                rate: 3.0,
                description: "KiwiSaver contributions by employers.",
            },
            accident_compensation: {
                rate: 1.39,
                description: "ACC levy paid by employers.",
            },
            total_employer_contribution: {
                rate: 4.39,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            kiwi_saver: {
                rate: 3.0,
                description: "KiwiSaver contributions by employees.",
            },
            total_employee_contribution: {
                rate: 3.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "0 - 14,000 NZD", rate: 10.5 },
            { range: "14,001 - 48,000 NZD", rate: 17.5 },
            { range: "48,001 - 70,000 NZD", rate: 30.0 },
            { range: "Over 70,001 NZD", rate: 33.0 },
        ],
    },
    {
        country: "Vietnam",
        currency: "VND",
        employer_contributions: {
            social_insurance: {
                rate: 17.5,
                description: "Social insurance contributions.",
            },
            health_insurance: {
                rate: 3.0,
                description: "Health insurance contributions.",
            },
            unemployment_insurance: {
                rate: 1.0,
                description: "Unemployment insurance contributions.",
            },
            total_employer_contribution: {
                rate: 21.5,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            social_insurance: {
                rate: 8.0,
                description: "Social insurance contributions.",
            },
            health_insurance: {
                rate: 1.5,
                description: "Health insurance contributions.",
            },
            unemployment_insurance: {
                rate: 1.0,
                description: "Unemployment insurance contributions.",
            },
            total_employee_contribution: {
                rate: 10.5,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "0 - 5,000,000 VND", rate: 5.0 },
            { range: "5,000,001 - 10,000,000 VND", rate: 10.0 },
            { range: "10,000,001 - 18,000,000 VND", rate: 15.0 },
            { range: "18,000,001 - 32,000,000 VND", rate: 20.0 },
            { range: "32,000,001 - 52,000,000 VND", rate: 25.0 },
            { range: "Above 52,000,001 VND", rate: 30.0 },
        ],
    }, {
        country: "Croatia",
        currency: "HRK",
        employer_contributions: {
            pension_contribution: {
                rate: 15.0,
                description: "Mandatory contributions for pension insurance.",
            },
            health_insurance: {
                rate: 16.5,
                description: "Health insurance contributions.",
            },
            total_employer_contribution: {
                rate: 31.5,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            pension_contribution: {
                rate: 5.0,
                description: "Mandatory contributions for pension insurance.",
            },
            health_insurance: {
                rate: 0.0,
                description: "No direct health insurance contribution from employees.",
            },
            total_employee_contribution: {
                rate: 5.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "0 - 3,800 HRK", rate: 20.0 },
            { range: "Above 3,800 HRK", rate: 30.0 },
        ],
    },
    {
        country: "Czech Republic",
        currency: "CZK",
        employer_contributions: {
            social_security: {
                rate: 24.8,
                description: "Social security contributions.",
            },
            health_insurance: {
                rate: 9.0,
                description: "Health insurance contributions.",
            },
            total_employer_contribution: {
                rate: 33.8,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            social_security: {
                rate: 6.5,
                description: "Social security contributions.",
            },
            health_insurance: {
                rate: 4.5,
                description: "Health insurance contributions.",
            },
            total_employee_contribution: {
                rate: 11.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "Up to 48,000 CZK", rate: 15.0 },
            { range: "Above 48,000 CZK", rate: 23.0 },
        ],
    },
    {
        country: "Egypt",
        currency: "EGP",
        employer_contributions: {
            social_insurance: {
                rate: 18.75,
                description: "Contributions to social insurance.",
            },
            total_employer_contribution: {
                rate: 18.75,
                description: "Total employer contribution as a percentage of income.",
            },
        },
        employee_contributions: {
            social_insurance: {
                rate: 14.0,
                description: "Contributions to social insurance.",
            },
            total_employee_contribution: {
                rate: 14.0,
                description: "Total employee contribution as a percentage of income.",
            },
        },
        income_tax_slabs: [
            { range: "0 - 15,000 EGP", rate: 0.0 },
            { range: "15,001 - 30,000 EGP", rate: 2.5 },
            { range: "30,001 - 45,000 EGP", rate: 10.0 },
            { range: "45,001 - 60,000 EGP", rate: 15.0 },
            { range: "Above 60,000 EGP", rate: 20.0 },
        ],
    },
      
    ],
  };
  